import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationClaimed = ({ entry, }) => {
    var _a;
    const authorName = getAuthorName(entry);
    const authorLink = _jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName }));
    const text = (_jsxs(_Fragment, { children: ["Conversation is claimed by ", authorLink, ' ', entry.claimed_from_type ? (_jsxs(_Fragment, { children: ["from ", entry.claimed_from_type.toLowerCase(), ' ', (_a = entry.claimed_from_label) !== null && _a !== void 0 ? _a : ''] })) : ('')] }));
    return _jsx(LogEntry, { entry: entry, text: text });
};
